import { h } from 'preact'
import { ForwardFn, forwardRef } from 'preact/compat'
import { useEffect, useState } from 'preact/hooks'
import cn from 'classnames'

import { Textarea } from 'components/ui'
import { TextArea as TextAreaField, TextareaFieldValue } from 'scripts/type'
import { usdDelayShow, useParentWindowSize } from 'scripts/hooks'

import SubmitButton from '../SubmitButton'
import styles from './index.scss'

type Props = {
  field: TextAreaField
  onSubmit: () => void
  onChange?: (value: TextareaFieldValue) => void
}

export type TextareaFieldRefType = {
  focus: () => void
}

const TextareaField: ForwardFn<Props, TextareaFieldRefType> = (props, ref) => {
  const { field, onChange, onSubmit } = props
  const { windowSizeSm } = useParentWindowSize()
  const [disableSubmit, setDisableSubmit] = useState(false)
  const [value, setValue] = useState<TextareaFieldValue>({ text: '', screenshots: [] })

  const { visible } = usdDelayShow(undefined, () => {
    if (!windowSizeSm) {
      // textAreaRef.current?.focus()
    }
  })

  useEffect(() => {
    onChange?.(value)
  }, [value])

  return (
    <div className={cn(styles.wrapper, visible && styles.show)}>
      <Textarea
        fieldCode={field.code}
        placeholder={field.label}
        screenshotsEnabled={field.screenshotsEnabled}
        onChange={(value) => setValue(value)}
        onUploadStart={() => setDisableSubmit(true)}
        onUploadEnd={() => setDisableSubmit(false)}
      />
      <SubmitButton onSubmit={onSubmit} disabled={disableSubmit} />
    </div>
  )
}

export default forwardRef(TextareaField)
